<template>
  <router-view />
</template>

<script>
export default {
  name: 'PublicApp',
}
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
}
</style>
